(() => {
  document.addEventListener('theme:cart:popdown', async (event) => {
    const settings = window.theme.settings;
    const drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!settings.cart_open_after_add || settings.cart_style !== 'drawer' || !drawer) return;
    event.stopImmediatePropagation();
    try {
      const response = await fetch(window.theme.routes.cart + '.js', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Unable to refresh cart');
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: { cart }, bubbles: true
      }));
    } catch (error) {
      console.warn('Unable to refresh cart before opening drawer', error);
    }
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    if (!window.theme.state.cartOpen) {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }, true);
})();
